/* eslint-disable max-classes-per-file */
import { defaults as _defaults } from 'lodash';
import { CurrencyType } from './Money';
var EmpType;
(function (EmpType) {
    EmpType[EmpType["None"] = 0] = "None";
    EmpType[EmpType["Employee"] = 1] = "Employee";
    EmpType[EmpType["Manager"] = 2] = "Manager";
    EmpType[EmpType["Executive"] = 3] = "Executive";
    EmpType[EmpType["Accountant"] = 4] = "Accountant";
    EmpType[EmpType["Guest"] = 5] = "Guest";
})(EmpType || (EmpType = {}));
class DelegateEmp {
    ID;
    Name;
    Email;
    constructor(params) {
        _defaults(this, params);
    }
}
const defaultEmployee = {
    CurrencyType: new CurrencyType(),
    FirstName: '',
    LastName: '',
    FullName: '',
    Email: '',
    EmpType: EmpType.None,
    EmployeeID: '',
    Language: null,
    UID: ''
};
class Employee {
    PK;
    ID;
    CurrencyType;
    FirstName;
    LastName;
    FullName;
    Email;
    EmpType;
    EmployeeID;
    Language;
    Company;
    UID;
    CreateDate;
    Department;
    Admin;
    EmpID;
    FName;
    LName;
    UsrPK;
    constructor(employee) {
        _defaults(this, employee);
    }
}
const defaultEmployeeOptions = {
    search: '',
    pagination: {
        page: 1,
        pageSize: 100,
        sort: { field: 'Usr_FName', sort: 'asc' }
    },
    empTypes: []
};
class GetEmployeeOptions {
    search;
    pagination;
    empTypes;
    constructor(employeeOptions) {
        _defaults(this, employeeOptions, defaultEmployeeOptions);
    }
}
export { DelegateEmp, EmpType, Employee, GetEmployeeOptions, defaultEmployee };
